import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { autoPlay } from "react-swipeable-views-utils-react-18-fix";

import SwipeableViews from 'react-swipeable-views-react-18-fix';

import MobileStepper from "@mui/material/MobileStepper";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

import carpetCleaning from "../../Assests/Images/carousal-carpet.jpg";
import facadeCleaning from "../../Assests/Images/carousal-facade.jpg";
import whiteWashing from "../../Assests/Images/carousal-Whitewashing.jpg";
import deepCleaning from "../../Assests/Images/carousal-deepCleaning.jpg";
import diamondPolish from "../../Assests/Images/carousal-diamond.jpg";
import pestControl from "../../Assests/Images/carousal-pest.jpg";

import "./Crousal.css";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [
  {
    header: "Professional Cleaning Excellence",
    label:
      "Discover the pinnacle of cleanliness and professionalism with our expert-level cleaning services for homes and businesses.",
    imgPath: carpetCleaning,
  },
  {
    header: "Diamond Floor Polishing",
    label:
      "A marble floor never looks better than when it is freshly polished. Keep your space shiny and timeless with regular polishing.",
    imgPath: diamondPolish,
  },
  {
    header: "Facade / Glass Cleaning",
    label:
      "Experience a new level of excellence with our expert facade cleaning services — restoring the brilliance of your exteriors.",
    imgPath: facadeCleaning,
  },
  {
    header: "Deep Cleaning",
    label:
      "Eliminate hidden allergens, bacteria, and dust with our deep cleaning service — ensuring a healthier, fresher environment.",
    imgPath: deepCleaning,
  },
  {
    header: "White Wash Paint Work",
    label:
      "Enhance your walls with a refreshing whitewash that adds brightness, cleanliness, and a sense of professionalism.",
    imgPath: whiteWashing,
  },
  {
    header: "Pest Control",
    label:
      "Protect your space from unwanted pests with our safe, effective pest control solutions for homes and businesses.",
    imgPath: pestControl,
  },
];

function Crousal() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);
  const handleStepChange = (step) => setActiveStep(step);

  return (
    <Box sx={{ flexGrow: 1, position: "relative" }} className="carousel-container">
      <AutoPlaySwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        interval={5000}
      >
        {images.map((step, index) => (
          <div key={step.header}>
            {Math.abs(activeStep - index) <= 2 ? (
              <Box
                component="div"
                className="carousel-slide"
                sx={{
                  backgroundImage: `url(${step.imgPath})`,
                }}
              >
                <div className="carousel-overlay">
                  <div className="carousel-text">
                    <h2 className="carousel-header">{step.header}</h2>
                    <p className="carousel-desc">{step.label}</p>
                  </div>
                </div>
              </Box>
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>

      <MobileStepper
        className="carousel-stepper"
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
            className="carousel-btn"
          >
            {theme.direction === "rtl" ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button
            size="small"
            onClick={handleBack}
            disabled={activeStep === 0}
            className="carousel-btn"
          >
            {theme.direction === "rtl" ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
          </Button>
        }
      />
    </Box>
  );
}

export default Crousal;
